module.exports = __webpack_public_path__ + "img/shop-icon-01.e99b12fd.png";